jQuery(document).ready(function ($) {
	/******************************************
    QTY Selector ( Simple quantity box increase / decrease )
   ******************************************/

	// PDP / PLP
	$('body').on('click', '.js-qty:not(.js-qty--cart)', function (e) {
		e.preventDefault();
		var $this = $(this);
		var $parent = $this.parent();
		var qtyInput = $parent.find('input');
		var qtyInputVal = qtyInput.val();
		const maxVal = parseInt(
			$(this).closest('.qty').find('input').attr('max')
		);
		qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;

		if ($this.hasClass('js-qty--plus')) {
			qtyInputVal++;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		} else {
			qtyInputVal--;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		}

		qtyInput.val(qtyInputVal);

		if (qtyInputVal > maxVal && maxVal > 0) {
			alert('Quantity entered exceeds available inventory.');
			$(this).closest('.qty').find('input').val(maxVal);
		}
	});

	$('body').on('input', '[sm-rc-quantity-selector]', function () {
		const qty = parseInt($(this).val());
		const maxVal = parseInt($(this).attr('max'));

		if (qty > maxVal) {
			alert('Quantity entered exceeds available inventory.');
			$(this).val(maxVal);
		}
	});

	$('body').on('click', '.card--product  .btn--atc', function () {
		var id = $(this).attr('data-id');

		CartJS.addItem(
			parseInt(id),
			1,
			{},
			{
				success: function (data, textStatus, jqXHR) {
					jQuery.getJSON('/cart.js', function (cart) {
						refreshMiniCart(cart);
					});
				},
				error: function (jqXHR, textStatus, errorThrown) {
					//error state
					console.log('Error: ' + errorThrown + '!');
				},
			}
		);
	});

	// MAIN CART

	// Allow typing of input qty for update
	var timer;
	$('.col__qty, .mobile-stuff').on('keyup', '.qty input', function () {
		var $this = $(this);
		var newVal = $this.val();
		var lineNum = $this.closest('.cart-row').attr('data-linenum');

		// clear the previous timer
		clearTimeout(timer);

		// create a new timer with a delay of 300ms seconds,
		// if the keyup is fired before the 300ms secs then the timer will be cleared
		timer = setTimeout(function () {
			// this will be executed if there is a gap of 300ms seconds between 2 keyup events
			CartJS.updateItem(
				lineNum,
				newVal,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						location.reload();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log(errorThrown);
					},
				}
			);
		}, 300);
	});

	$('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
		e.preventDefault();

		var $this = $(this);
		var qtyInput = $this.closest('.qty').find('input');
		var qtyInputVal = qtyInput.val();
		qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
		var lineNum = $this.closest('.cart-row').attr('data-linenum');

		if ($this.hasClass('js-qty--plus')) {
			qtyInputVal++;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		} else {
			qtyInputVal--;
			qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
		}

		if (qtyInputVal >= 1) {
			// console.log('got here');
			CartJS.updateItem(
				lineNum,
				qtyInputVal,
				{},
				{
					success: function (data, textStatus, jqXHR) {
						location.reload();
					},
					error: function (jqXHR, textStatus, errorThrown) {
						console.log(errorThrown);
					},
				}
			);
		} else {
			CartJS.removeItem(lineNum, {
				success: function (data, textStatus, jqXHR) {
					location.reload();
				},
				error: function (jqXHR, textStatus, errorThrown) {
					console.log(errorThrown);
				},
			});
		}
	});

	// MAIN CART REMOVE
	$('.actions .remove-product').on('click', function (e) {
		e.preventDefault();
		var $this = $(this);
		var lineID = $this.closest('.cart-row').attr('data-lineid');

		CartJS.removeItemById(lineID, {
			success: function (data, textStatus, jqXHR) {
				location.reload();
			},
			error: function (jqXHR, textStatus, errorThrown) {},
		});
	});

	/******************************************
    Options to change SM-RC Widget dropdowns
   ******************************************/

	// SELECT TYPE
	$('body').on('change', '.option__wrap select', function () {
		var optionVal = $(this).val();
		var optionNum = $(this).closest('.option__wrap').attr('data-option');

		$('select[' + optionNum + ']')
			.val(optionVal)
			.change();
	});

	// BUTTON TYPE
	$('body').on('click', '.option__wrap button', function (e) {
		var optionVal = $(this).attr('data-val');
		var optionNum = $(this).closest('.option__wrap').attr('data-option');

		if ($(this).hasClass('btn--swatch')) {
			$(this).closest('.option__wrap').find('.color-val').text(optionVal);
		}

		// Set visual display of active
		$(this).closest('.option__wrap').find('button').removeClass('active');
		$(this).addClass('active');

		$('select[' + optionNum + ']')
			.val(optionVal)
			.change();
	});

	// RECHARE WIDGET VARIANTS
	$('.pdp__recharge input').on('click', function () {
		if ($(this).val() == 'rc-yes') {
			$('.form__group--rc').show();
			var planId = $(this)
				.closest('.pdp__recharge')
				.find('.frequency-select')
				.val();
			$('[sm-rc-plan-selector]').val(planId).change();
		} else {
			$('.form__group--rc').hide();
			$('[sm-rc-plan-selector]').val('false').change();
		}
	});

	// RECHARE WIDGET SUBSCRIPTION PLAN
	$('.template__product .frequency-select').on('change', function () {
		var planId = $(this).val();
		$('[sm-rc-plan-selector]').val(planId).change();
	});
});
